export const addUserResponseHelpers = {
    is_user_id_searchable(value) {
        return Boolean(value) && typeof value === "object";
    },

    get_possible_user_email(value) {
        return String(value.email || value.username || "").toLowerCase();
    },

    has_matching_fallback_email(possible_email, fallback_email) {
        return fallback_email
            ? possible_email === String(fallback_email).toLowerCase()
            : true;
    },

    get_direct_user_id(value, fallback_email = "") {
        const possible_id = value.id || value.user_id || value.pk;

        return this.get_allowed_user_id(possible_id, this.get_possible_user_email(value), fallback_email);
    },

    get_allowed_user_id(possible_id, possible_email, fallback_email) {
        if (!possible_id) return null;
        return this.can_use_possible_user_id(possible_email, fallback_email) ? possible_id : null;
    },

    can_use_possible_user_id(possible_email, fallback_email) {
        return !possible_email || this.has_matching_fallback_email(possible_email, fallback_email);
    },

    find_user_id_in_nested_value(nested_value, fallback_email = "") {
        if (Array.isArray(nested_value)) {
            return nested_value
                .map((item) => this.find_user_id_in_response(item, fallback_email))
                .find(Boolean) || null;
        }

        return this.find_user_id_in_response(nested_value, fallback_email);
    },

    find_user_id_in_response(value, fallback_email = "") {
        if (!this.is_user_id_searchable(value)) {
            return null;
        }

        return this.get_direct_user_id(value, fallback_email)
            || this.find_user_id_in_nested_values(value, fallback_email);
    },

    find_user_id_in_nested_values(value, fallback_email = "") {
        return Object.values(value)
            .map((nested_value) => this.find_user_id_in_nested_value(nested_value, fallback_email))
            .find(Boolean) || null;
    },

    get_created_user_id(response_data, fallback_email = "") {
        const direct_id = this.find_user_id_in_response(response_data, fallback_email);

        if (direct_id) {
            return direct_id;
        }

        const matching_user = this.users.find((existing_user) => {
            return String(existing_user.email || "").toLowerCase() === String(fallback_email || "").toLowerCase();
        });

        return matching_user?.id || null;
    }
};
